/**
 * keycloak-js uses crypto.randomUUID(), which browsers only expose in secure contexts
 * (HTTPS or localhost). On HTTP LAN hosts (e.g. QA VM), polyfill via getRandomValues.
 */
export function applyInsecureContextCryptoPolyfill(): void {
  const cryptoApi = globalThis.crypto;
  if (!cryptoApi || typeof cryptoApi.getRandomValues !== 'function') return;
  if (typeof cryptoApi.randomUUID === 'function') return;

  cryptoApi.randomUUID = function randomUUID() {
    const bytes = new Uint8Array(16);
    cryptoApi.getRandomValues(bytes);
    bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
    bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
    const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  };
}
